import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["source", "tooltip"]

  copy() {
    const text = this.sourceTarget.textContent.trim()

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => this.showTooltip())
    } else {
      this.fallbackCopy(text)
    }
  }

  // Deprecated fallback for browsers without Clipboard API
  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
    this.showTooltip()
  }

  showTooltip() {
    if (!this.hasTooltipTarget) return

    this.tooltipTarget.classList.add("is-visible")
    setTimeout(() => {
      this.tooltipTarget.classList.remove("is-visible")
    }, 2000)
  }
}
